import { useContext } from "react";

import "./portfolio.scss";

import data from "../../pages/data/projects.json";

import { ThemeContext } from "../../App";
import Preview from "../preview/preview";

function Portfolio() {
  const { openOverlay, setOverlayTheme } = useContext(ThemeContext);

  return (
    <div className="portfolio">
      <div className="portfolio__list">
        {data.items &&
          data.items.map((item, index) => (
            <div
              className={`portfolio__list-item`}
              onClick={() => {
                setOverlayTheme("dark");
                openOverlay(item);
              }}
              key={`portfolio__list-item-${index}`}
            >
              <Preview {...item} />
            </div>
          ))}
      </div>
    </div>
  );
}

export default Portfolio;
